/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Source of truth: tokens/*.json (design/09 §2, §4.2, §5.1, §5.3, §6, §7.2, §7.3).
 * Regenerate with: npm run tokens:build
 *
 * Editing this file is a design/09 §12 criterion 1 violation waiting to happen:
 * the no-colour-literal lint exempts this path precisely because it is generated,
 * so a hand-written hex here would be invisible to the check that exists to catch it.
 */

export const CSS_VAR_PREFIX = '--bata' as const;

export const THEMES = ['light', 'dark'] as const;
export type Theme = (typeof THEMES)[number];

export const tokenNames = [
  'border-focus',
  'border-focus-offset',
  'border-hairline',
  'breakpoint-2xl',
  'breakpoint-lg',
  'breakpoint-md',
  'breakpoint-sm',
  'breakpoint-xl',
  'breakpoint-xs',
  'calculator-inputs',
  'chart-caps-axis-label-digits',
  'chart-caps-categorical-series',
  'chart-caps-clustered-x-categories',
  'chart-caps-direct-label-series',
  'chart-caps-scatter-series',
  'chart-caps-stacked-x-categories',
  'chart-categorical-1',
  'chart-categorical-2',
  'chart-categorical-3',
  'chart-categorical-4',
  'chart-categorical-5',
  'chart-categorical-6',
  'chart-categorical-7',
  'chart-diverging-0',
  'chart-diverging-1',
  'chart-diverging-2',
  'chart-diverging-3',
  'chart-diverging-4',
  'chart-diverging-5',
  'chart-diverging-6',
  'chart-ink-annotation',
  'chart-ink-axis-label',
  'chart-ink-subtitle',
  'chart-ink-title',
  'chart-missing-not-ranged',
  'chart-missing-not-reported',
  'chart-ordinal-dark-1',
  'chart-ordinal-dark-2',
  'chart-ordinal-dark-3',
  'chart-ordinal-dark-4',
  'chart-ordinal-dark-5',
  'chart-ordinal-dark-6',
  'chart-ordinal-light-1',
  'chart-ordinal-light-2',
  'chart-ordinal-light-3',
  'chart-ordinal-light-4',
  'chart-ordinal-light-5',
  'chart-ordinal-light-6',
  'chart-ordinal-light-7',
  'chart-sequential-blue-100',
  'chart-sequential-blue-250',
  'chart-sequential-blue-400',
  'chart-sequential-blue-50',
  'chart-sequential-blue-500',
  'chart-sequential-blue-600',
  'chart-sequential-blue-700',
  'chart-sequential-blue-800',
  'chart-sequential-blue-900',
  'chart-sequential-orange-100',
  'chart-sequential-orange-250',
  'chart-sequential-orange-400',
  'chart-sequential-orange-50',
  'chart-sequential-orange-500',
  'chart-sequential-orange-600',
  'chart-sequential-orange-700',
  'chart-sequential-orange-800',
  'chart-sequential-orange-900',
  'chart-structure-axis',
  'chart-structure-fill-gap',
  'chart-structure-grid',
  'chart-structure-line-width',
  'chart-structure-marker-size',
  'chart-structure-target-band',
  'chrome-header-height',
  'chrome-sidebar-width',
  'chrome-sidebar-width-collapsed',
  'color-brand-red',
  'color-crumb-link',
  'color-delta-negative',
  'color-delta-neutral',
  'color-delta-positive',
  'color-focus-ring',
  'color-ghost',
  'color-hairline',
  'color-health-broken',
  'color-health-broken-on',
  'color-health-broken-text',
  'color-health-estimate-zone',
  'color-health-low',
  'color-health-low-text',
  'color-health-low-tint',
  'color-health-na',
  'color-health-na-dot',
  'color-health-na-ground',
  'color-health-na-text',
  'color-health-na-tint',
  'color-health-ok',
  'color-health-ok-text',
  'color-health-ok-tint',
  'color-health-out',
  'color-health-out-on',
  'color-health-out-text',
  'color-health-uncovered-cell',
  'color-hero-caption',
  'color-hero-rule',
  'color-ink-label',
  'color-ink-muted',
  'color-ink-on-brand',
  'color-ink-primary',
  'color-ink-secondary',
  'color-mark-neutral',
  'color-mark-optima-accent',
  'color-menu-active',
  'color-pill',
  'color-pill-hover',
  'color-popover-border',
  'color-rail-active',
  'color-rail-bg',
  'color-rail-fg',
  'color-rail-fg-entry',
  'color-rail-fg-future',
  'color-rail-fg-quiet',
  'color-rail-fg-secondary',
  'color-rail-hairline',
  'color-rail-hover',
  'color-rail-raised',
  'color-rail-veil',
  'color-ramp-brand-red-hover',
  'color-ramp-brand-red-wash',
  'color-ramp-neutral-darkest',
  'color-ramp-neutral-lightest',
  'color-ramp-neutral-mid',
  'color-rule-soft',
  'color-scrim',
  'color-separator',
  'color-status-critical',
  'color-status-critical-strong',
  'color-status-good',
  'color-status-good-strong',
  'color-status-serious',
  'color-status-warning',
  'color-strip-choose',
  'color-strip-error',
  'color-strip-error-fg',
  'color-strip-error-fg-secondary',
  'color-strip-hatch',
  'color-surface-constants',
  'color-surface-detail',
  'color-surface-emphasis',
  'color-surface-emphasis-head',
  'color-surface-error-row',
  'color-surface-page',
  'color-surface-raised',
  'color-surface-sunken',
  'color-surface-technical-row',
  'density-comfortable',
  'density-compact',
  'density-default',
  'density-text-comfortable',
  'density-text-compact',
  'density-text-default',
  'density-total-row',
  'font-family-display',
  'font-family-numeric',
  'font-family-ui',
  'font-weight-bold',
  'font-weight-medium',
  'font-weight-regular',
  'font-weight-semibold',
  'grid-columns',
  'grid-gutter',
  'list-width',
  'motion-chart',
  'motion-default',
  'motion-easing',
  'motion-easing-out',
  'motion-enter',
  'motion-exit',
  'motion-fast',
  'motion-instant',
  'motion-shake',
  'page-margin',
  'page-max-width',
  'panel-width',
  'plot-height',
  'plot-max-height',
  'radius-button',
  'radius-cell',
  'radius-chip',
  'radius-control',
  'radius-field',
  'radius-full',
  'shadow-overlay',
  'shadow-popover',
  'space-0',
  'space-1',
  'space-12',
  'space-16',
  'space-2',
  'space-3',
  'space-4',
  'space-6',
  'space-8',
  'text-measure',
  'toc-width',
  'type-body-case',
  'type-body-family',
  'type-body-line-height',
  'type-body-size',
  'type-body-strong-case',
  'type-body-strong-family',
  'type-body-strong-line-height',
  'type-body-strong-size',
  'type-body-strong-tracking',
  'type-body-strong-weight',
  'type-body-tracking',
  'type-body-weight',
  'type-caption-case',
  'type-caption-family',
  'type-caption-line-height',
  'type-caption-size',
  'type-caption-tracking',
  'type-caption-weight',
  'type-display-case',
  'type-display-family',
  'type-display-hero-case',
  'type-display-hero-family',
  'type-display-hero-line-height',
  'type-display-hero-size',
  'type-display-hero-tracking',
  'type-display-hero-weight',
  'type-display-line-height',
  'type-display-size',
  'type-display-tracking',
  'type-display-weight',
  'type-label-case',
  'type-label-family',
  'type-label-line-height',
  'type-label-size',
  'type-label-tracking',
  'type-label-weight',
  'type-metric-case',
  'type-metric-family',
  'type-metric-line-height',
  'type-metric-size',
  'type-metric-tracking',
  'type-metric-weight',
  'type-micro-case',
  'type-micro-family',
  'type-micro-line-height',
  'type-micro-size',
  'type-micro-tracking',
  'type-micro-weight',
  'type-numeric-case',
  'type-numeric-family',
  'type-numeric-line-height',
  'type-numeric-size',
  'type-numeric-strong-case',
  'type-numeric-strong-family',
  'type-numeric-strong-line-height',
  'type-numeric-strong-size',
  'type-numeric-strong-tracking',
  'type-numeric-strong-weight',
  'type-numeric-tracking',
  'type-numeric-weight',
  'type-section-case',
  'type-section-family',
  'type-section-line-height',
  'type-section-size',
  'type-section-tracking',
  'type-section-weight',
  'type-subsection-case',
  'type-subsection-family',
  'type-subsection-line-height',
  'type-subsection-size',
  'type-subsection-tracking',
  'type-subsection-weight',
  'z-chrome',
  'z-grid-header',
  'z-grid-pinned',
  'z-grid-pinned-header',
  'z-modal',
  'z-popover',
  'z-toast',
] as const;
export type TokenName = (typeof tokenNames)[number];

const light = {
  'border-focus': "2px",
  'border-focus-offset': "2px",
  'border-hairline': "1px",
  'breakpoint-2xl': "1920px",
  'breakpoint-lg': "1200px",
  'breakpoint-md': "1024px",
  'breakpoint-sm': "768px",
  'breakpoint-xl': "1440px",
  'breakpoint-xs': "375px",
  'calculator-inputs': "400px",
  'chart-caps-axis-label-digits': "3",
  'chart-caps-categorical-series': "7",
  'chart-caps-clustered-x-categories': "5",
  'chart-caps-direct-label-series': "4",
  'chart-caps-scatter-series': "3",
  'chart-caps-stacked-x-categories': "7",
  'chart-categorical-1': "#2a78d6",
  'chart-categorical-2': "#eb6834",
  'chart-categorical-3': "#1baf7a",
  'chart-categorical-4': "#eda100",
  'chart-categorical-5': "#e87ba4",
  'chart-categorical-6': "#008300",
  'chart-categorical-7': "#4a3aa7",
  'chart-diverging-0': "#621b1a",
  'chart-diverging-1': "#94605a",
  'chart-diverging-2': "#c3a5a0",
  'chart-diverging-3': "#f0efec",
  'chart-diverging-4': "#a0aec1",
  'chart-diverging-5': "#567196",
  'chart-diverging-6': "#0d366b",
  'chart-ink-annotation': "#756e65",
  'chart-ink-axis-label': "#756e65",
  'chart-ink-subtitle': "#756e65",
  'chart-ink-title': "#140000",
  'chart-missing-not-ranged': "#f5f3f0",
  'chart-missing-not-reported': "#e7e6dd",
  'chart-ordinal-dark-1': "#5273a0",
  'chart-ordinal-dark-2': "#6a89b2",
  'chart-ordinal-dark-3': "#829ec4",
  'chart-ordinal-dark-4': "#9ab5d6",
  'chart-ordinal-dark-5': "#b3cbe8",
  'chart-ordinal-dark-6': "#cde2fb",
  'chart-ordinal-light-1': "#9ab5d6",
  'chart-ordinal-light-2': "#829ec4",
  'chart-ordinal-light-3': "#6a89b2",
  'chart-ordinal-light-4': "#5273a0",
  'chart-ordinal-light-5': "#3c5f8e",
  'chart-ordinal-light-6': "#254a7c",
  'chart-ordinal-light-7': "#0d366b",
  'chart-sequential-blue-100': "#b3cbe8",
  'chart-sequential-blue-250': "#9ab5d6",
  'chart-sequential-blue-400': "#829ec4",
  'chart-sequential-blue-50': "#cde2fb",
  'chart-sequential-blue-500': "#6a89b2",
  'chart-sequential-blue-600': "#5273a0",
  'chart-sequential-blue-700': "#3c5f8e",
  'chart-sequential-blue-800': "#254a7c",
  'chart-sequential-blue-900': "#0d366b",
  'chart-sequential-orange-100': "#e6bfb1",
  'chart-sequential-orange-250': "#d3a797",
  'chart-sequential-orange-400': "#c08f7e",
  'chart-sequential-orange-50': "#f9d7cb",
  'chart-sequential-orange-500': "#ad7865",
  'chart-sequential-orange-600': "#9a624d",
  'chart-sequential-orange-700': "#874b36",
  'chart-sequential-orange-800': "#74351e",
  'chart-sequential-orange-900': "#611f02",
  'chart-structure-axis': "#e7e6dd",
  'chart-structure-fill-gap': "2px",
  'chart-structure-grid': "#e7e6dd",
  'chart-structure-line-width': "2px",
  'chart-structure-marker-size': "8px",
  'chart-structure-target-band': "#e7e6dd",
  'chrome-header-height': "56px",
  'chrome-sidebar-width': "240px",
  'chrome-sidebar-width-collapsed': "56px",
  'color-brand-red': "#d40001",
  'color-crumb-link': "#5b5550",
  'color-delta-negative': "#d03b3b",
  'color-delta-neutral': "#756e65",
  'color-delta-positive': "#006300",
  'color-focus-ring': "#d40001",
  'color-ghost': "#f0ede8",
  'color-hairline': "#e7e6dd",
  'color-health-broken': "#7b4b94",
  'color-health-broken-on': "#ffffff",
  'color-health-broken-text': "#6a3a84",
  'color-health-estimate-zone': "#f7f5f0",
  'color-health-low': "#c98a12",
  'color-health-low-text': "#8a5a00",
  'color-health-low-tint': "#f7ead0",
  'color-health-na': "#aba79b",
  'color-health-na-dot': "#8a847b",
  'color-health-na-ground': "#e3dfd5",
  'color-health-na-text': "#5b5550",
  'color-health-na-tint': "#f3f1ec",
  'color-health-ok': "#3f7d55",
  'color-health-ok-text': "#1f6b3a",
  'color-health-ok-tint': "#e3efe6",
  'color-health-out': "#b3261e",
  'color-health-out-on': "#ffffff",
  'color-health-out-text': "#b3261e",
  'color-health-uncovered-cell': "#f4d6d3",
  'color-hero-caption': "#d9d5cc",
  'color-hero-rule': "rgba(255, 255, 255, 0.14)",
  'color-ink-label': "#5b5550",
  'color-ink-muted': "#aba79b",
  'color-ink-on-brand': "#ffffff",
  'color-ink-primary': "#140000",
  'color-ink-secondary': "#756e65",
  'color-mark-neutral': "#8a847b",
  'color-mark-optima-accent': "#d40001",
  'color-menu-active': "#f6f2e9",
  'color-pill': "#f0ede8",
  'color-pill-hover': "#e7e6dd",
  'color-popover-border': "#140000",
  'color-rail-active': "#2a1a1a",
  'color-rail-bg': "#140000",
  'color-rail-fg': "#ffffff",
  'color-rail-fg-entry': "#d9d5cc",
  'color-rail-fg-future': "#6f6862",
  'color-rail-fg-quiet': "#8a847b",
  'color-rail-fg-secondary': "#aba79b",
  'color-rail-hairline': "#3a2b2b",
  'color-rail-hover': "#241414",
  'color-rail-raised': "#241414",
  'color-rail-veil': "rgba(20, 0, 0, 0.72)",
  'color-ramp-brand-red-hover': "#b00001",
  'color-ramp-brand-red-wash': "#fbe5e5",
  'color-ramp-neutral-darkest': "#3a2b2b",
  'color-ramp-neutral-lightest': "#faf8f5",
  'color-ramp-neutral-mid': "#8f887e",
  'color-rule-soft': "#e3dfd5",
  'color-scrim': "rgba(253, 252, 251, 0.7)",
  'color-separator': "#d6d2c7",
  'color-status-critical': "#d03b3b",
  'color-status-critical-strong': "#b3261e",
  'color-status-good': "#0ca30c",
  'color-status-good-strong': "#1f6b3a",
  'color-status-serious': "#ec835a",
  'color-status-warning': "#fab219",
  'color-strip-choose': "#f6f2e9",
  'color-strip-error': "#140000",
  'color-strip-error-fg': "#ffffff",
  'color-strip-error-fg-secondary': "#d9d5cc",
  'color-strip-hatch': "#ece9e1",
  'color-surface-constants': "#f3f1ec",
  'color-surface-detail': "#f9f8f6",
  'color-surface-emphasis': "#f6f2e9",
  'color-surface-emphasis-head': "#efe9dc",
  'color-surface-error-row': "#fbf1f0",
  'color-surface-page': "#fdfcfb",
  'color-surface-raised': "#ffffff",
  'color-surface-sunken': "#f5f3f0",
  'color-surface-technical-row': "#f7f5f0",
  'density-comfortable': "48px",
  'density-compact': "32px",
  'density-default': "40px",
  'density-text-comfortable': "14px",
  'density-text-compact': "13px",
  'density-text-default': "14px",
  'density-total-row': "44px",
  'font-family-display': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'font-family-numeric': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'font-family-ui': "'DM Sans', system-ui, Arial, sans-serif",
  'font-weight-bold': "700",
  'font-weight-medium': "500",
  'font-weight-regular': "400",
  'font-weight-semibold': "600",
  'grid-columns': "12",
  'grid-gutter': "24px",
  'list-width': "340px",
  'motion-chart': "800ms",
  'motion-default': "180ms",
  'motion-easing': "cubic-bezier(0.2, 0, 0.2, 1)",
  'motion-easing-out': "cubic-bezier(0.2, 0.8, 0.2, 1)",
  'motion-enter': "450ms",
  'motion-exit': "300ms",
  'motion-fast': "120ms",
  'motion-instant': "0ms",
  'motion-shake': "350ms",
  'page-margin': "32px",
  'page-max-width': "1760px",
  'panel-width': "360px",
  'plot-height': "240px",
  'plot-max-height': "320px",
  'radius-button': "20px",
  'radius-cell': "0px",
  'radius-chip': "2px",
  'radius-control': "4px",
  'radius-field': "5px",
  'radius-full': "9999px",
  'shadow-overlay': "0 4px 16px rgb(20 0 0 / 0.18)",
  'shadow-popover': "0 8px 24px rgb(20 0 0 / 0.18)",
  'space-0': "0px",
  'space-1': "4px",
  'space-12': "48px",
  'space-16': "64px",
  'space-2': "8px",
  'space-3': "12px",
  'space-4': "16px",
  'space-6': "24px",
  'space-8': "32px",
  'text-measure': "min(68ch, 720px)",
  'toc-width': "240px",
  'type-body-case': "none",
  'type-body-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-body-line-height': "20px",
  'type-body-size': "14px",
  'type-body-strong-case': "none",
  'type-body-strong-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-body-strong-line-height': "20px",
  'type-body-strong-size': "14px",
  'type-body-strong-tracking': "0",
  'type-body-strong-weight': "600",
  'type-body-tracking': "0",
  'type-body-weight': "400",
  'type-caption-case': "none",
  'type-caption-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-caption-line-height': "16px",
  'type-caption-size': "12px",
  'type-caption-tracking': "0",
  'type-caption-weight': "400",
  'type-display-case': "uppercase",
  'type-display-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-display-hero-case': "uppercase",
  'type-display-hero-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-display-hero-line-height': "1",
  'type-display-hero-size': "clamp(48px, 5.6vw, 84px)",
  'type-display-hero-tracking': "0.005em",
  'type-display-hero-weight': "700",
  'type-display-line-height': "1.06",
  'type-display-size': "clamp(32px, 2.8vw, 40px)",
  'type-display-tracking': "0",
  'type-display-weight': "700",
  'type-label-case': "none",
  'type-label-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-label-line-height': "16px",
  'type-label-size': "12px",
  'type-label-tracking': "0",
  'type-label-weight': "500",
  'type-metric-case': "none",
  'type-metric-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-metric-line-height': "32px",
  'type-metric-size': "28px",
  'type-metric-tracking': "0",
  'type-metric-weight': "500",
  'type-micro-case': "uppercase",
  'type-micro-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-micro-line-height': "14px",
  'type-micro-size': "11px",
  'type-micro-tracking': "0.04em",
  'type-micro-weight': "500",
  'type-numeric-case': "none",
  'type-numeric-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-numeric-line-height': "20px",
  'type-numeric-size': "13px",
  'type-numeric-strong-case': "none",
  'type-numeric-strong-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-numeric-strong-line-height': "20px",
  'type-numeric-strong-size': "13px",
  'type-numeric-strong-tracking': "0",
  'type-numeric-strong-weight': "600",
  'type-numeric-tracking': "0",
  'type-numeric-weight': "400",
  'type-section-case': "uppercase",
  'type-section-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-section-line-height': "26px",
  'type-section-size': "20px",
  'type-section-tracking': "0",
  'type-section-weight': "700",
  'type-subsection-case': "none",
  'type-subsection-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-subsection-line-height': "20px",
  'type-subsection-size': "15px",
  'type-subsection-tracking': "0",
  'type-subsection-weight': "600",
  'z-chrome': "20",
  'z-grid-header': "10",
  'z-grid-pinned': "11",
  'z-grid-pinned-header': "12",
  'z-modal': "40",
  'z-popover': "45",
  'z-toast': "50",
} as const;

const dark = {
  'border-focus': "2px",
  'border-focus-offset': "2px",
  'border-hairline': "1px",
  'breakpoint-2xl': "1920px",
  'breakpoint-lg': "1200px",
  'breakpoint-md': "1024px",
  'breakpoint-sm': "768px",
  'breakpoint-xl': "1440px",
  'breakpoint-xs': "375px",
  'calculator-inputs': "400px",
  'chart-caps-axis-label-digits': "3",
  'chart-caps-categorical-series': "7",
  'chart-caps-clustered-x-categories': "5",
  'chart-caps-direct-label-series': "4",
  'chart-caps-scatter-series': "3",
  'chart-caps-stacked-x-categories': "7",
  'chart-categorical-1': "#3987e5",
  'chart-categorical-2': "#d95926",
  'chart-categorical-3': "#199e70",
  'chart-categorical-4': "#c98500",
  'chart-categorical-5': "#d55181",
  'chart-categorical-6': "#008300",
  'chart-categorical-7': "#9085e9",
  'chart-diverging-0': "#ffaba3",
  'chart-diverging-1': "#b8837c",
  'chart-diverging-2': "#765c57",
  'chart-diverging-3': "#383835",
  'chart-diverging-4': "#586473",
  'chart-diverging-5': "#7a94b7",
  'chart-diverging-6': "#9ec7ff",
  'chart-ink-annotation': "#aba79b",
  'chart-ink-axis-label': "#aba79b",
  'chart-ink-subtitle': "#aba79b",
  'chart-ink-title': "#f3efe6",
  'chart-missing-not-ranged': "#0d0000",
  'chart-missing-not-reported': "#3a2b2b",
  'chart-ordinal-dark-1': "#5273a0",
  'chart-ordinal-dark-2': "#6a89b2",
  'chart-ordinal-dark-3': "#829ec4",
  'chart-ordinal-dark-4': "#9ab5d6",
  'chart-ordinal-dark-5': "#b3cbe8",
  'chart-ordinal-dark-6': "#cde2fb",
  'chart-ordinal-light-1': "#9ab5d6",
  'chart-ordinal-light-2': "#829ec4",
  'chart-ordinal-light-3': "#6a89b2",
  'chart-ordinal-light-4': "#5273a0",
  'chart-ordinal-light-5': "#3c5f8e",
  'chart-ordinal-light-6': "#254a7c",
  'chart-ordinal-light-7': "#0d366b",
  'chart-sequential-blue-100': "#b3cbe8",
  'chart-sequential-blue-250': "#9ab5d6",
  'chart-sequential-blue-400': "#829ec4",
  'chart-sequential-blue-50': "#cde2fb",
  'chart-sequential-blue-500': "#6a89b2",
  'chart-sequential-blue-600': "#5273a0",
  'chart-sequential-blue-700': "#3c5f8e",
  'chart-sequential-blue-800': "#254a7c",
  'chart-sequential-blue-900': "#0d366b",
  'chart-sequential-orange-100': "#e6bfb1",
  'chart-sequential-orange-250': "#d3a797",
  'chart-sequential-orange-400': "#c08f7e",
  'chart-sequential-orange-50': "#f9d7cb",
  'chart-sequential-orange-500': "#ad7865",
  'chart-sequential-orange-600': "#9a624d",
  'chart-sequential-orange-700': "#874b36",
  'chart-sequential-orange-800': "#74351e",
  'chart-sequential-orange-900': "#611f02",
  'chart-structure-axis': "#3a2b2b",
  'chart-structure-fill-gap': "2px",
  'chart-structure-grid': "#3a2b2b",
  'chart-structure-line-width': "2px",
  'chart-structure-marker-size': "8px",
  'chart-structure-target-band': "#3a2b2b",
  'chrome-header-height': "56px",
  'chrome-sidebar-width': "240px",
  'chrome-sidebar-width-collapsed': "56px",
  'color-brand-red': "#d40001",
  'color-crumb-link': "#aba79b",
  'color-delta-negative': "#e66767",
  'color-delta-neutral': "#aba79b",
  'color-delta-positive': "#0ca30c",
  'color-focus-ring': "#ff4d4d",
  'color-ghost': "#2a1717",
  'color-hairline': "#3a2b2b",
  'color-health-broken': "#b98fd0",
  'color-health-broken-on': "#140000",
  'color-health-broken-text': "#cfa8e4",
  'color-health-estimate-zone': "#2a1a1a",
  'color-health-low': "#e0a83a",
  'color-health-low-text': "#f0c060",
  'color-health-low-tint': "#3a2c10",
  'color-health-na': "#6f6862",
  'color-health-na-dot': "#6f6862",
  'color-health-na-ground': "#2a1a1a",
  'color-health-na-text': "#aba79b",
  'color-health-na-tint': "#2a1a1a",
  'color-health-ok': "#6fb38a",
  'color-health-ok-text': "#8fd0a8",
  'color-health-ok-tint': "#1f3a2a",
  'color-health-out': "#ff6b61",
  'color-health-out-on': "#140000",
  'color-health-out-text': "#ff6b61",
  'color-health-uncovered-cell': "#5a1f1c",
  'color-hero-caption': "#d9d5cc",
  'color-hero-rule': "rgba(255, 255, 255, 0.14)",
  'color-ink-label': "#aba79b",
  'color-ink-muted': "#756e65",
  'color-ink-on-brand': "#ffffff",
  'color-ink-primary': "#f3efe6",
  'color-ink-secondary': "#aba79b",
  'color-mark-neutral': "#8a847b",
  'color-mark-optima-accent': "#ff4d4f",
  'color-menu-active': "#2a1a1a",
  'color-pill': "#2a1717",
  'color-pill-hover': "#3a2b2b",
  'color-popover-border': "#3a2b2b",
  'color-rail-active': "#2a1a1a",
  'color-rail-bg': "#0d0000",
  'color-rail-fg': "#ffffff",
  'color-rail-fg-entry': "#d9d5cc",
  'color-rail-fg-future': "#6f6862",
  'color-rail-fg-quiet': "#8a847b",
  'color-rail-fg-secondary': "#aba79b",
  'color-rail-hairline': "#4a3838",
  'color-rail-hover': "#1f0e0e",
  'color-rail-raised': "#1f0e0e",
  'color-rail-veil': "rgba(13, 0, 0, 0.72)",
  'color-ramp-brand-red-hover': "#ff4d4d",
  'color-ramp-brand-red-wash': "#3b1212",
  'color-ramp-neutral-darkest': "#e7e6dd",
  'color-ramp-neutral-lightest': "#1c0a0a",
  'color-ramp-neutral-mid': "#8f887e",
  'color-rule-soft': "#3a2b2b",
  'color-scrim': "rgba(20, 0, 0, 0.7)",
  'color-separator': "#3a2b2b",
  'color-status-critical': "#d03b3b",
  'color-status-critical-strong': "#ff6b61",
  'color-status-good': "#0ca30c",
  'color-status-good-strong': "#7fc795",
  'color-status-serious': "#ec835a",
  'color-status-warning': "#fab219",
  'color-strip-choose': "#2a1a1a",
  'color-strip-error': "#f3efe6",
  'color-strip-error-fg': "#140000",
  'color-strip-error-fg-secondary': "#5b5550",
  'color-strip-hatch': "#1f1414",
  'color-surface-constants': "#2a1a1a",
  'color-surface-detail': "#1f1414",
  'color-surface-emphasis': "#2a1a1a",
  'color-surface-emphasis-head': "#2a1a1a",
  'color-surface-error-row': "#2a1414",
  'color-surface-page': "#140000",
  'color-surface-raised': "#1f1414",
  'color-surface-sunken': "#0d0000",
  'color-surface-technical-row': "#0d0000",
  'density-comfortable': "48px",
  'density-compact': "32px",
  'density-default': "40px",
  'density-text-comfortable': "14px",
  'density-text-compact': "13px",
  'density-text-default': "14px",
  'density-total-row': "44px",
  'font-family-display': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'font-family-numeric': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'font-family-ui': "'DM Sans', system-ui, Arial, sans-serif",
  'font-weight-bold': "700",
  'font-weight-medium': "500",
  'font-weight-regular': "400",
  'font-weight-semibold': "600",
  'grid-columns': "12",
  'grid-gutter': "24px",
  'list-width': "340px",
  'motion-chart': "800ms",
  'motion-default': "180ms",
  'motion-easing': "cubic-bezier(0.2, 0, 0.2, 1)",
  'motion-easing-out': "cubic-bezier(0.2, 0.8, 0.2, 1)",
  'motion-enter': "450ms",
  'motion-exit': "300ms",
  'motion-fast': "120ms",
  'motion-instant': "0ms",
  'motion-shake': "350ms",
  'page-margin': "32px",
  'page-max-width': "1760px",
  'panel-width': "360px",
  'plot-height': "240px",
  'plot-max-height': "320px",
  'radius-button': "20px",
  'radius-cell': "0px",
  'radius-chip': "2px",
  'radius-control': "4px",
  'radius-field': "5px",
  'radius-full': "9999px",
  'shadow-overlay': "0 4px 16px rgb(20 0 0 / 0.18)",
  'shadow-popover': "0 8px 24px rgb(0 0 0 / 0.55)",
  'space-0': "0px",
  'space-1': "4px",
  'space-12': "48px",
  'space-16': "64px",
  'space-2': "8px",
  'space-3': "12px",
  'space-4': "16px",
  'space-6': "24px",
  'space-8': "32px",
  'text-measure': "min(68ch, 720px)",
  'toc-width': "240px",
  'type-body-case': "none",
  'type-body-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-body-line-height': "20px",
  'type-body-size': "14px",
  'type-body-strong-case': "none",
  'type-body-strong-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-body-strong-line-height': "20px",
  'type-body-strong-size': "14px",
  'type-body-strong-tracking': "0",
  'type-body-strong-weight': "600",
  'type-body-tracking': "0",
  'type-body-weight': "400",
  'type-caption-case': "none",
  'type-caption-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-caption-line-height': "16px",
  'type-caption-size': "12px",
  'type-caption-tracking': "0",
  'type-caption-weight': "400",
  'type-display-case': "uppercase",
  'type-display-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-display-hero-case': "uppercase",
  'type-display-hero-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-display-hero-line-height': "1",
  'type-display-hero-size': "clamp(48px, 5.6vw, 84px)",
  'type-display-hero-tracking': "0.005em",
  'type-display-hero-weight': "700",
  'type-display-line-height': "1.06",
  'type-display-size': "clamp(32px, 2.8vw, 40px)",
  'type-display-tracking': "0",
  'type-display-weight': "700",
  'type-label-case': "none",
  'type-label-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-label-line-height': "16px",
  'type-label-size': "12px",
  'type-label-tracking': "0",
  'type-label-weight': "500",
  'type-metric-case': "none",
  'type-metric-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-metric-line-height': "32px",
  'type-metric-size': "28px",
  'type-metric-tracking': "0",
  'type-metric-weight': "500",
  'type-micro-case': "uppercase",
  'type-micro-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-micro-line-height': "14px",
  'type-micro-size': "11px",
  'type-micro-tracking': "0.04em",
  'type-micro-weight': "500",
  'type-numeric-case': "none",
  'type-numeric-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-numeric-line-height': "20px",
  'type-numeric-size': "13px",
  'type-numeric-strong-case': "none",
  'type-numeric-strong-family': "'IBM Plex Mono', ui-monospace, 'Cascadia Mono', Consolas, monospace",
  'type-numeric-strong-line-height': "20px",
  'type-numeric-strong-size': "13px",
  'type-numeric-strong-tracking': "0",
  'type-numeric-strong-weight': "600",
  'type-numeric-tracking': "0",
  'type-numeric-weight': "400",
  'type-section-case': "uppercase",
  'type-section-family': "Antonio, Oswald, 'Arial Narrow', sans-serif",
  'type-section-line-height': "26px",
  'type-section-size': "20px",
  'type-section-tracking': "0",
  'type-section-weight': "700",
  'type-subsection-case': "none",
  'type-subsection-family': "'DM Sans', system-ui, Arial, sans-serif",
  'type-subsection-line-height': "20px",
  'type-subsection-size': "15px",
  'type-subsection-tracking': "0",
  'type-subsection-weight': "600",
  'z-chrome': "20",
  'z-grid-header': "10",
  'z-grid-pinned': "11",
  'z-grid-pinned-header': "12",
  'z-modal': "40",
  'z-popover': "45",
  'z-toast': "50",
} as const;

/**
 * Both themes, independently. design/09 §9: "Both modes are first-class, both
 * are validated against their own surface, and the theme toggle wins over the OS
 * setting in both directions." Neither of these objects is derived from the other.
 */
export const themes: Record<Theme, Record<TokenName, string>> = { light, dark };

export const colourTokenNames = [
  'chart-categorical-1',
  'chart-categorical-2',
  'chart-categorical-3',
  'chart-categorical-4',
  'chart-categorical-5',
  'chart-categorical-6',
  'chart-categorical-7',
  'chart-diverging-0',
  'chart-diverging-1',
  'chart-diverging-2',
  'chart-diverging-3',
  'chart-diverging-4',
  'chart-diverging-5',
  'chart-diverging-6',
  'chart-ink-annotation',
  'chart-ink-axis-label',
  'chart-ink-subtitle',
  'chart-ink-title',
  'chart-missing-not-ranged',
  'chart-missing-not-reported',
  'chart-ordinal-dark-1',
  'chart-ordinal-dark-2',
  'chart-ordinal-dark-3',
  'chart-ordinal-dark-4',
  'chart-ordinal-dark-5',
  'chart-ordinal-dark-6',
  'chart-ordinal-light-1',
  'chart-ordinal-light-2',
  'chart-ordinal-light-3',
  'chart-ordinal-light-4',
  'chart-ordinal-light-5',
  'chart-ordinal-light-6',
  'chart-ordinal-light-7',
  'chart-sequential-blue-100',
  'chart-sequential-blue-250',
  'chart-sequential-blue-400',
  'chart-sequential-blue-50',
  'chart-sequential-blue-500',
  'chart-sequential-blue-600',
  'chart-sequential-blue-700',
  'chart-sequential-blue-800',
  'chart-sequential-blue-900',
  'chart-sequential-orange-100',
  'chart-sequential-orange-250',
  'chart-sequential-orange-400',
  'chart-sequential-orange-50',
  'chart-sequential-orange-500',
  'chart-sequential-orange-600',
  'chart-sequential-orange-700',
  'chart-sequential-orange-800',
  'chart-sequential-orange-900',
  'chart-structure-axis',
  'chart-structure-grid',
  'chart-structure-target-band',
  'color-brand-red',
  'color-crumb-link',
  'color-delta-negative',
  'color-delta-neutral',
  'color-delta-positive',
  'color-focus-ring',
  'color-ghost',
  'color-hairline',
  'color-health-broken',
  'color-health-broken-on',
  'color-health-broken-text',
  'color-health-estimate-zone',
  'color-health-low',
  'color-health-low-text',
  'color-health-low-tint',
  'color-health-na',
  'color-health-na-dot',
  'color-health-na-ground',
  'color-health-na-text',
  'color-health-na-tint',
  'color-health-ok',
  'color-health-ok-text',
  'color-health-ok-tint',
  'color-health-out',
  'color-health-out-on',
  'color-health-out-text',
  'color-health-uncovered-cell',
  'color-hero-caption',
  'color-hero-rule',
  'color-ink-label',
  'color-ink-muted',
  'color-ink-on-brand',
  'color-ink-primary',
  'color-ink-secondary',
  'color-mark-neutral',
  'color-mark-optima-accent',
  'color-menu-active',
  'color-pill',
  'color-pill-hover',
  'color-popover-border',
  'color-rail-active',
  'color-rail-bg',
  'color-rail-fg',
  'color-rail-fg-entry',
  'color-rail-fg-future',
  'color-rail-fg-quiet',
  'color-rail-fg-secondary',
  'color-rail-hairline',
  'color-rail-hover',
  'color-rail-raised',
  'color-rail-veil',
  'color-ramp-brand-red-hover',
  'color-ramp-brand-red-wash',
  'color-ramp-neutral-darkest',
  'color-ramp-neutral-lightest',
  'color-ramp-neutral-mid',
  'color-rule-soft',
  'color-scrim',
  'color-separator',
  'color-status-critical',
  'color-status-critical-strong',
  'color-status-good',
  'color-status-good-strong',
  'color-status-serious',
  'color-status-warning',
  'color-strip-choose',
  'color-strip-error',
  'color-strip-error-fg',
  'color-strip-error-fg-secondary',
  'color-strip-hatch',
  'color-surface-constants',
  'color-surface-detail',
  'color-surface-emphasis',
  'color-surface-emphasis-head',
  'color-surface-error-row',
  'color-surface-page',
  'color-surface-raised',
  'color-surface-sunken',
  'color-surface-technical-row',
] as const;
export type ColourTokenName = (typeof colourTokenNames)[number];

/**
 * The ONLY sanctioned way for application code to reference a colour. Returns a
 * `var()` reference, so the value follows the active theme without the component
 * knowing which theme is active.
 */
export function cssVar(name: TokenName): string {
  return `var(${CSS_VAR_PREFIX}-${name})`;
}

/**
 * A resolved literal for the one consumer that cannot use a CSS variable: the
 * charting library, which computes marks in canvas and needs a real colour.
 * Application code outside src/charts/ should use `cssVar` instead.
 */
export function tokenValue(name: TokenName, theme: Theme): string {
  return themes[theme][name];
}

// ── typed views over the token set ───────────────────────────────────────────

/** design/09 §6 — three row heights, user-selectable and persisted per user. */
export const DENSITY_MODES = ['comfortable', 'default', 'compact'] as const;
export type DensityMode = (typeof DENSITY_MODES)[number];
export const densityRowHeight: Record<DensityMode, number> = {
  comfortable: 48,
  default: 40,
  compact: 32,
};

/** Brief part 1 §1 — the text size each density carries (13 / 14 / 14 px). */
export const densityTextSize: Record<DensityMode, number> = {
  comfortable: 14,
  default: 14,
  compact: 13,
};

/** Brief part 1 §1 — the totals row is this tall in EVERY density. */
export const DENSITY_TOTAL_ROW_HEIGHT = 44;

/** design/09 §7.2 — capped at SEVEN slots, not eight. */
export const CATEGORICAL_SLOTS = [1, 2, 3, 4, 5, 6, 7] as const;
export type CategoricalSlot = (typeof CATEGORICAL_SLOTS)[number];
export const CATEGORICAL_SLOT_COUNT = 7;

/** design/09 §7.3 — index 0 is furthest below plan, 3 is the neutral midpoint. */
export const DIVERGING_STEPS = 7;
export const DIVERGING_MIDPOINT = 3;

export const SEQUENTIAL_STEPS = [50, 100, 250, 400, 500, 600, 700, 800, 900] as const;
export type SequentialStep = (typeof SEQUENTIAL_STEPS)[number];

/** design/09 §4.2 — every named entry in the application type scale. */
export const TYPE_SCALE = [
  'display-hero',
  'display',
  'section',
  'subsection',
  'body',
  'body-strong',
  'label',
  'caption',
  'micro',
  'numeric',
  'numeric-strong',
  'metric',
] as const;
export type TypeScaleName = (typeof TYPE_SCALE)[number];

/** design/09 §2.2 / §6 — breakpoints inherited verbatim from production. */
export const BREAKPOINTS = {
  xs: 375,
  sm: 768,
  md: 1024,
  lg: 1200,
  xl: 1440,
  '2xl': 1920,
} as const;

/** §2.5 element caps, read from tokens so no chart hard-codes them. */
export const CHART_CAPS = {
  stackedXCategories: 7,
  clusteredXCategories: 5,
  scatterSeries: 3,
  categoricalSeries: 7,
  directLabelSeries: 4,
  axisLabelDigits: 3,
} as const;
